type LabelProps = {
  text: string;
};

const Label = ({ text }: LabelProps) => {
  return <label className="w-full font-bold">{text}</label>;
};

export default Label;
